/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _menu = __webpack_require__(1);

	var _menu2 = _interopRequireDefault(_menu);

	var _sliders = __webpack_require__(3);

	var _sliders2 = _interopRequireDefault(_sliders);

	var _searchBlock = __webpack_require__(4);

	var _searchBlock2 = _interopRequireDefault(_searchBlock);

	var _searchPage = __webpack_require__(5);

	var _searchPage2 = _interopRequireDefault(_searchPage);

	var _eventsCalendar = __webpack_require__(6);

	var _eventsCalendar2 = _interopRequireDefault(_eventsCalendar);

	var _ieDetector = __webpack_require__(7);

	var _ieDetector2 = _interopRequireDefault(_ieDetector);

	var _messages = __webpack_require__(8);

	var _messages2 = _interopRequireDefault(_messages);

	var _stickyHeader = __webpack_require__(9);

	var _stickyHeader2 = _interopRequireDefault(_stickyHeader);

	var _jsFormValidate = __webpack_require__(10);

	var _jsFormValidate2 = _interopRequireDefault(_jsFormValidate);

	var _regionalMap = __webpack_require__(11);

	var _regionalMap2 = _interopRequireDefault(_regionalMap);

	var _archiveCalendar = __webpack_require__(12);

	var _archiveCalendar2 = _interopRequireDefault(_archiveCalendar);

	var _select = __webpack_require__(13);

	var _select2 = _interopRequireDefault(_select);

	var _calendarEqualHeight = __webpack_require__(14);

	var _calendarEqualHeight2 = _interopRequireDefault(_calendarEqualHeight);

	var _windowResize = __webpack_require__(15);

	var _windowResize2 = _interopRequireDefault(_windowResize);

	var _ajaxComplete = __webpack_require__(17);

	var _ajaxComplete2 = _interopRequireDefault(_ajaxComplete);

	var _pagination = __webpack_require__(18);

	var _pagination2 = _interopRequireDefault(_pagination);

	var _accordion = __webpack_require__(19);

	var _accordion2 = _interopRequireDefault(_accordion);

	var _magazineArchive = __webpack_require__(20);

	var _magazineArchive2 = _interopRequireDefault(_magazineArchive);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	//import EqualHeights from './_site/equalHeights';
	jQuery(function () {
		// Site Menu
		_menu2.default.init();

		// Slick Slider
		_sliders2.default.init();

		// Search
		_searchBlock2.default.init();

		// Search Page
		_searchPage2.default.init();

		//Accordion
		_accordion2.default.init();

		//Events Calendar
		_eventsCalendar2.default.init();

		//Archive Calendar
		_archiveCalendar2.default.init();

		//IE
		_ieDetector2.default.init();

		_calendarEqualHeight2.default.init();

		// Sticky header
		_stickyHeader2.default.init();

		// Sticky header
		_regionalMap2.default.init();

		// Frontend form validation
		_jsFormValidate2.default.init();

		// Select 2
		_select2.default.init();

		//Messages
		_messages2.default.init();

		//Window Resize
		_windowResize2.default.init();

		// Pagination
		_pagination2.default.init();

		// Ajax complete
		_ajaxComplete2.default.init();

		//MagazineArchive
		_magazineArchive2.default.init();
	});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var Menu = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domMenuBtn: $('.js-menu-btn'),
		$domMenuNav: $('.js-main-nav'),
		$userIcon: $('.user-icon'),
		$userIconLogedIn: $('.user-icon-loged-in'),
		$userAccountMenu: $('#block-drupal-starter-account-menu'),
		$domMenuHasSub: $('.js-main-nav .menu-item--expanded'),
		classOpen: 'open',
		classOpenMenu: 'menu-open',
		classSubMenu: '.menu-item--expanded > .menu',
		classSubIcon: '.sub-icon',
		classMenu: '.menu',
		classList: 'li',

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {

			// functions
			var closeNav = function closeNav() {
				Menu.$domMenuBtn.removeClass(Menu.classOpen);
				Menu.$domMenuNav.removeClass(Menu.classOpen).find(Menu.classSubMenu).slideUp();
				Menu.$domMenuNav.find(Menu.classSubIcon).removeClass(Menu.classOpen);
				_global2.default.$domBody.removeClass(Menu.classOpenMenu);
			};

			if (_global2.default.varsWindowWidth < 992) {
				Menu.$domMenuHasSub.each(function (i, el) {
					$(el).append('<span class="sub-icon font-plus-circle" data-open-sub></span>');
				});
			}

			// bind events
			Menu.$domMenuBtn.on('click', function (e) {
				e.preventDefault();
				Menu.$domMenuBtn.toggleClass(Menu.classOpen);
				Menu.$domMenuNav.toggleClass(Menu.classOpen).find(Menu.classSubMenu).slideUp();
				Menu.$domMenuNav.find(Menu.classSubIcon).removeClass('open');
				_global2.default.$domBody.toggleClass(Menu.classOpenMenu);
				$('.site-content').toggleClass('overlay');
			});

			Menu.$domMenuNav.on('click', '[data-open-sub]', function (e) {
				var self = $(e.currentTarget);

				if (self.hasClass(Menu.classOpen)) {
					self.removeClass(Menu.classOpen).siblings(Menu.classSubMenu).slideUp();
					self.siblings().find(Menu.classSubIcon).removeClass(Menu.classOpen);
					self.siblings().find(Menu.classMenu).slideUp();
				} else {
					self.addClass(Menu.classOpen).siblings(Menu.classSubMenu).slideDown();
					self.parent().siblings(Menu.classList).find(Menu.classSubIcon).removeClass(Menu.classOpen);
					self.parent().siblings(Menu.classList).find(Menu.classMenu).slideUp();
				}
			});

			Menu.$userIcon.on('click', function (e) {
				Menu.$userAccountMenu.toggleClass('open');
			});

			Menu.$userIconLogedIn.on('click', function (e) {
				Menu.$userAccountMenu.toggleClass('open');
			});

			_global2.default.functions.clickOutsideContainer(Menu.$domMenuNav, Menu.$domMenuNav.find('ul'), Menu.$domMenuBtn, Menu.$userIcon, closeNav);

			_global2.default.functions.escKey(closeNav);
		}
	};

	exports.default = Menu;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var Global = {
		$domWindow: $(window),
		$domDoc: $(document),
		$domBody: $('body'),

		varsWindowWidth: window.innerWidth,

		functions: {
			escKey: function escKey(callback) {
				Global.$domDoc.on('keyup', function (e) {
					if (e.keyCode === 27) {
						callback();
					}
				});
			},

			clickOutsideContainer: function clickOutsideContainer(selector, container, closeBtn, callback) {
				selector.on('mouseup', function (e) {
					e.preventDefault();
					if (!container.is(e.target) && container.has(e.target).length === 0 && !closeBtn.is(e.target)) {
						callback();
					}
				});
			}
		}
	};

	exports.default = Global;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Sliders = {
		/*-------------------------------------------------------------------------------
	 # Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domSlider: $('.js-slider'),
		$domSliderBanner: $('.js-slider-banner'),
		$latestNewsSlider: $('#block-views-block-latest-news-block-1').find('.view-latest-news').find('.views-rows'),
		$latestNewsBg: $('#block-views-block-latest-news-block-1').find('.view-latest-news').find('.views-rows').find('.views-row-background'),
		$featuredEventsSlider: $('#block-views-block-events-listing-block-1').find('.view-events-listing').find('.views-rows'),
		$partnersSlider: $('.view-id-simple_ad').find('.views-rows'),
		$eventsSlider: $('.field-field_events'),
		$pageEventsSlider: $('.layout-main-top').find('#block-views-block-events-listing-block-1').find('.view-events-listing').find('.views-rows'),

		/*-------------------------------------------------------------------------------
	 # Initialize
	 -------------------------------------------------------------------------------*/

		init: function init() {

			Sliders.$latestNewsBg.each(function (index, el) {
				var attr = $(el).attr('data-background-image-url');
				var newAttr = attr.split('?')[0];
				$(el).css('background-image', 'url(' + newAttr + ')');
			});

			// Banner Slider
			Sliders.$domSliderBanner.slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 1000,
				arrows: true,
				autoplay: true,
				dots: true,
				pauseOnHover: true,
				pauseOnFocus: false,
				fade: true,
				autoplaySpeed: 4000
			});

			//LatestNews Slider
			Sliders.$latestNewsSlider.slick({
				infinite: true,
				slidesToShow: 4,
				slidesToScroll: 1,
				speed: 1000,
				arrows: true,
				autoplay: true,
				dots: false,
				pauseOnHover: true,
				pauseOnFocus: false,
				autoplaySpeed: 4000,
				responsive: [{
					breakpoint: 580,
					settings: {
						slidesToShow: 1
					}
				}, {
					breakpoint: 1024,
					settings: {
						slidesToShow: 2
					}
				}]
			});

			// Featured Events Slider
			if (!$('body').hasClass('page-events')) {
				Sliders.$featuredEventsSlider.slick({
					infinite: true,
					rows: 3,
					slidesToShow: 1,
					slidesToScroll: 1,
					speed: 1000,
					arrows: false,
					autoplay: true,
					dots: true,
					pauseOnHover: true,
					pauseOnFocus: false,
					autoplaySpeed: 4000
				});
			}

			//Partners Slider
			Sliders.$partnersSlider.slick({
				infinite: true,
				slidesToShow: 6,
				slidesToScroll: 6,
				speed: 1000,
				arrows: false,
				autoplay: true,
				dots: true,
				pauseOnHover: true,
				pauseOnFocus: false,
				autoplaySpeed: 4000,
				responsive: [{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}]
			});

			//Events Slider
			$('.field-field_events').slick({
				infinite: true,
				slidesToShow: 5,
				slidesToScroll: 5,
				speed: 1000,
				arrows: true,
				autoplay: true,
				dots: true,
				pauseOnHover: true,
				pauseOnFocus: false,
				autoplaySpeed: 4000,
				responsive: [{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}, {
					breakpoint: 1200,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3
					}
				}]
			});

			// Page events slider
			Sliders.$pageEventsSlider.slick({
				infinite: true,
				slidesToShow: 5,
				slidesToScroll: 5,
				speed: 1000,
				arrows: true,
				autoplay: true,
				dots: true,
				pauseOnHover: true,
				pauseOnFocus: false,
				autoplaySpeed: 4000,
				responsive: [{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}, {
					breakpoint: 1200,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3
					}
				}]
			});
		}
	};

	exports.default = Sliders;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var SearchBlock = {
	  $accountMenu: $('.account-menu-block').find('#block-drupal-starter-account-menu'),
	  $searchForm: $('#masthead').find('#views-exposed-form-search-page-1'),
	  $searchInputWrap: $('#masthead').find('#views-exposed-form-search-page-1').find('.form-item-search-api-fulltext'),
	  $searchInput: $('#masthead').find('#views-exposed-form-search-page-1').find('#edit-search-api-fulltext'),
	  $searchBtn: $('#masthead').find('#views-exposed-form-search-page-1').find('[id*="edit-submit-search"]'),

	  init: function init() {

	    SearchBlock.$searchBtn.on('click', function (event, el) {
	      event.preventDefault();
	      event.stopPropagation();

	      if (!SearchBlock.$searchInputWrap.hasClass('expanded')) {

	        SearchBlock.$searchInputWrap.addClass('expanded');
	        SearchBlock.$accountMenu.addClass('hidden');
	        SearchBlock.$searchInput.focus();

	        if ($(window).width() <= 768) {
	          $('.user-icon').addClass('hidden');
	          $('.c-menu-btn').addClass('hidden');
	          $('.account-menu-block').addClass('mobPos');
	          $('.header--main').find('.c-branding').addClass('searchActive');
	        }

	        if ($(window).width() > 768 && $(window).width() < 1300) {
	          $('.c-main-navigation').addClass('hidden');
	        }
	      } else {
	        if (SearchBlock.$searchInput.val() == '') {
	          SearchBlock.$searchInputWrap.removeClass('expanded');
	          SearchBlock.$accountMenu.removeClass('hidden');

	          if ($(window).width() <= 768) {
	            $('.user-icon').removeClass('hidden');
	            $('.c-menu-btn').removeClass('hidden');
	            $('.account-menu-block').removeClass('mobPos');
	            $('.header--main').find('.c-branding').removeClass('searchActive');
	          }

	          if ($(window).width() > 768 && $(window).width() < 1300) {
	            $('.c-main-navigation').removeClass('hidden');
	          }
	        } else {
	          SearchBlock.$searchForm.trigger('submit');
	        }
	      }
	    });

	    $(document).click(function (e) {
	      var inputElementCheck = e.target.id != $('#edit-search-api-fulltext').attr('id');
	      if (SearchBlock.$searchInput.val() === '' && inputElementCheck) {
	        SearchBlock.$searchInputWrap.removeClass('expanded');
	        SearchBlock.$accountMenu.removeClass('hidden');
	      }
	    });
	  }
	};

	exports.default = SearchBlock;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var SearchPage = {
	  $searchRadioInput: $('.search-selector').find('ul').find('li').find('.option'),
	  $searchRadioItem: $('.search-selector').find('ul').find('li'),
	  $contentSearch: $('.page-search').find('#block-exposed-form-search-page'),
	  $usersSearch: $('.page-search').find('#block-exposed-form-search-users'),

	  init: function init() {
	    //Set active state on rado redirected page from members aria
	    if ($('body').hasClass('page-users')) {
	      $('#radio-users').addClass('checked').parent().addClass('checked');
	      $('#radio-users').parent().siblings().removeClass('checked');
	      $('#radio-content').removeClass('checked').removeAttr('checked');
	      Cookies.remove('inputchecked', 'content');
	    } else {
	      $('#radio-content').addClass('checked').parent().addClass('checked');
	      $('#radio-content').parent().siblings().removeClass('checked');
	      $('#radio-users').removeClass('checked').removeAttr('checked');
	      Cookies.remove('inputchecked', 'users');
	    }

	    SearchPage.$usersSearch.addClass('hidden');
	    var cookieContent = Cookies.get('inputchecked', 'content');
	    var cookieUsers = Cookies.get('inputchecked', 'users');

	    SearchPage.$searchRadioInput.each(function (index, radioInput) {
	      var curentInput = $(radioInput);
	      var curentInputVal = curentInput.siblings().attr('value');

	      // Cookies.remove('inputchecked','users');

	      if (curentInputVal == cookieContent) {
	        curentInput.addClass('checked');
	        curentInput.siblings('input[type="radio"]').addClass('checked');
	        curentInput.parent().addClass('checked');
	        curentInput.parent().siblings().children('input[type="radio"]').removeAttr('checked');
	      } else {
	        if (curentInputVal == cookieUsers) {
	          curentInput.addClass('checked');
	          curentInput.siblings('input[type="radio"]').addClass('checked');
	          curentInput.parent().addClass('checked');
	          curentInput.parent().siblings().children('input[type="radio"]').removeAttr('checked');
	        }
	      }
	    });

	    SearchPage.$searchRadioInput.on('click', function (e) {
	      var checked = $(e.currentTarget).siblings().attr('value');
	      $(e.currentTarget).siblings('input[type="radio"]').addClass('checked');
	      $(e.currentTarget).parent().addClass('checked');

	      //Set cookie expire
	      var date = new Date();
	      date.setTime(date.getTime() + 15 * 60 * 1000); //15 min


	      Cookies.set('inputchecked', checked, {
	        expires: date,
	        path: '/'
	      });

	      if ($(e.currentTarget).parent().hasClass('checked')) {
	        $(e.currentTarget).parent().siblings().removeClass('checked');
	        $(e.currentTarget).parent().siblings().children().removeClass('checked');
	        $(e.currentTarget).parent().siblings().children().removeAttr('checked');
	      } else {
	        // Cookies.remove('checkSearchType')
	      }

	      SearchPage.$searchRadioItem.each(function (index, radioItem) {
	        var item = $(radioItem);
	        var itemAttr = $(radioItem).attr('class');
	        var inputVal = $(radioItem).children('input').attr('value');

	        if (itemAttr == 'form-type-radio checked' && inputVal == 'content') {
	          SearchPage.$contentSearch.css('display', 'block');
	          SearchPage.$usersSearch.css('display', 'none');
	        } else {
	          if (itemAttr == 'form-type-radio checked' && inputVal == 'users') {
	            SearchPage.$usersSearch.css('display', 'block');
	            SearchPage.$contentSearch.css('display', 'none');
	          }
	        }
	      });
	    });
	  }
	};

	exports.default = SearchPage;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var EventsCalendar = {
	    $eventsWeek: $('.js-drupal-fullcalendar').find('.fc-day-number'),
	    $calendar: $('.js-drupal-fullcalendar'),

	    init: function init() {
	        //console.log('EventsCalendar');

	        if (EventsCalendar.$calendar.length) {
	            EventsCalendar.$calendar.fullCalendar('destroy');

	            EventsCalendar.$calendar.fullCalendar({
	                header: {
	                    left: 'prev,next today',
	                    center: 'title',
	                    right: drupalSettings.rightButtons
	                },
	                defaultDate: drupalSettings.defaultDate,
	                locale: drupalSettings.defaultLang,
	                navLinks: drupalSettings.navLinks == 0 ? false : true,
	                editable: true,
	                eventLimit: false,
	                events: drupalSettings.fullCalendarView,
	                eventOverlap: false,
	                contentHeight: 'auto',
	                // handleWindowResize:true,
	                eventAfterAllRender: function eventAfterAllRender() {
	                    $('.js-drupal-fullcalendar').addClass('loaded');
	                    // console.log('The new title of the view is ' + view.title);

	                    if ($('.fc-view').hasClass('fc-month-view')) {
	                        $('.fc-month-button').css('display', 'none');
	                    } else {
	                        if ($('.fc-view').hasClass('fc-basicDay-view')) {
	                            $('.fc-month-button').css('display', 'block');
	                            var day = $('.fc-view').find('.fc-content-skeleton').find('td');

	                            if (!day.html().length) {
	                                day.html('<p class="empty-day"> There are no events for this day. </p>');
	                            }
	                        }
	                    }
	                },

	                eventRender: function eventRender(event, element) {
	                    var dataToFind = moment(event.start).format('YYYY-MM-DD');
	                    $("td[data-date='" + dataToFind + "']").addClass('activeDay');
	                    $('.fc-month-button').removeClass('fc-state-active');
	                }
	            });
	        }
	    }
	};

	exports.default = EventsCalendar;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	       value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var IeDetector = {

	       init: function init() {
	              var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);

	              if (isIE11) {
	                     $('body').addClass('ie11');
	              }
	       }
	};

	exports.default = IeDetector;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var Messages = {
	    $statusMessages: $('body').find('div[aria-label*="Status message"]'),
	    $errorMessages: $('body').find('div[aria-label*="Error message"]'),
	    $warningMessages: $('body').find('div[aria-label="Warning message"]'),
	    $resetPassLink: $('.login-wrapper').find('.s-login-reset-pass'),
	    $popupMessage: $('.login-wrapper').find('.popup-message'),

	    init: function init() {
	        Messages.$statusMessages.on('click', function (e) {
	            var targetMessage = $(e.currentTarget);
	            targetMessage.addClass('hide');
	        });

	        Messages.$errorMessages.on('click', function (e) {
	            var targetMessage = $(e.currentTarget);
	            targetMessage.addClass('hide');
	        });

	        Messages.$warningMessages.on('click', function (e) {
	            var targetMessage = $(e.currentTarget);
	            targetMessage.addClass('hide');
	        });

	        var popupInit = function popupInit() {
	            if (Messages.$popupMessage.hasClass('open')) {
	                Messages.$popupMessage.removeClass('open');
	            } else {
	                Messages.$popupMessage.addClass('open');
	            }
	        };

	        if ($(window).width() <= 768) {
	            Messages.$resetPassLink.on('click', function (e) {
	                $(e.currentTarget).toggleClass('activate');

	                if ($(e.currentTarget).hasClass('activate')) {
	                    e.preventDefault();
	                    popupInit();
	                } else {}
	            });
	        } else {
	            Messages.$resetPassLink.on('mouseover mouseout', function () {
	                popupInit();
	            });
	        }
	    }
	};

	exports.default = Messages;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var Sticky = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$header: $('.js-header'),
		$content: $('.js-site-content'),
		classSticky: 'sticky-header',
		classStickyContent: 'sticky-content',

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {

			$(window).on('scroll', function () {
				if ($(window).scrollTop() >= 30) {
					Sticky.$content.addClass(Sticky.classStickyContent);
					Sticky.$header.addClass(Sticky.classSticky);
				} else {
					Sticky.$content.removeClass(Sticky.classStickyContent);
					Sticky.$header.removeClass(Sticky.classSticky);
				}
			});
		}
	};

	exports.default = Sticky;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var FormValidate = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		// Use this class for every form you whant to validate
		classForm: '.js-validation',

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			if ($(FormValidate.classForm).length > 0) {
				$.validate({
					form: FormValidate.classForm
				});
			}
		}
	};

	exports.default = FormValidate;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line

	var RegionalMap = {
	    /*-------------------------------------------------------------------------------
	    	# Cache dom and strings
	    -------------------------------------------------------------------------------*/

	    /*-------------------------------------------------------------------------------
	    # Initialize
	    -------------------------------------------------------------------------------*/
	    init: function init() {
	        var sideListItem = $('.regions-list-item');
	        var mapItem = $('.regions-page-map').find('#regions').find('#group-main').find('.aria');
	        var number = $('.map-number');
	        var popup = $('.regions-page-map').find('.popup');

	        sideListItem.on('mouseover mouseout', function (e) {
	            var listItem = $(e.currentTarget);
	            var listItemLink = listItem.find('a');
	            var sideItemAttr = listItem.find('.region-list-item-number').html();

	            listItemLink.toggleClass('hovered');

	            mapItem.each(function (index, el) {
	                var mapItemAttr = $(el).attr('id');

	                if (sideItemAttr == mapItemAttr && listItemLink.hasClass('hovered')) {
	                    $(el).addClass('colored').siblings().removeClass('colored');
	                } else {
	                    $(el).removeClass('colored');
	                }
	            });

	            popup.each(function (index, el) {
	                var currentPopupId = $(el).attr('id');

	                if (currentPopupId == sideItemAttr && listItemLink.hasClass('hovered')) {
	                    $(el).addClass('visible');
	                } else {
	                    $(el).removeClass('visible');
	                }
	            });
	        });

	        mapItem.on('click', function (e) {
	            var clickedItem = $(e.currentTarget);
	            var clickedItemId = clickedItem.attr('id');

	            sideListItem.each(function (index, el) {
	                var sideItemNum = $(el).find('.region-list-item-number').html();

	                if (clickedItemId == sideItemNum) {
	                    $(el).find('a')[0].click();
	                }
	            });
	        });

	        mapItem.on('mouseover mouseout', function (e) {
	            var hoverItem = $(e.currentTarget);
	            var hoveredItemId = hoverItem.attr('id');

	            popup.each(function (index, el) {
	                var currentPopupId = $(el).attr('id');

	                if (currentPopupId == hoveredItemId) {
	                    $(el).toggleClass('visible');
	                }
	            });

	            sideListItem.each(function (index, el) {
	                var sideItemNum = $(el).find('.region-list-item-number').html();

	                if (sideItemNum == hoveredItemId) {
	                    $(el).toggleClass('colored').siblings().removeClass('colored');
	                }
	            });
	        });
	    }
	};

	exports.default = RegionalMap;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line

	var ArchiveCalendar = {

	    $visibleDate: $('.archive-main-wrapper').find('[class*="-year"]').find('.month').find('a'),
	    $hiddenDate: $('.hide').find('ul').find('li').find('a'),

	    init: function init() {

	        ArchiveCalendar.$hiddenDate.each(function (index, el) {
	            var hiddenDate = $(el).attr('href');
	            //  console.log(hiddenDate);

	            ArchiveCalendar.$visibleDate.each(function (index, date) {
	                var dateLink = $(date);
	                var attrLink = $(date).attr('href');
	                //console.log(attrLink);

	                if (hiddenDate == attrLink) {
	                    dateLink.addClass('colored');
	                }
	            });
	        });
	    }
	};

	exports.default = ArchiveCalendar;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Select2 = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$contactPageSelect: $('.page-node-webform').find('select'),
		$regionalNewsSelect: $('#block-views-block-regional-news-block-1').find('#views-exposed-form-regional-news-block-1').find('select'),

		/*-------------------------------------------------------------------------------
	 # Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			// drupal fix for multilingual
			var selectPlaceholder = Drupal.t("Enquiry");

			$('select').select2({
				placeholder: '' + selectPlaceholder
			});

			Select2.$contactPageSelect.select2({
				placeholder: 'Enquiry',
				minimumResultsForSearch: 5
			});
		}
	};

	exports.default = Select2;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var CalendarEqualHeight = {

	  init: function init() {

	    var equalHeightsEventTop = function equalHeightsEventTop() {
	      var featuredEventsBlock = $('#block-views-block-events-listing-block-1').find('.view-events-listing');
	      var calendar = $('.js-drupal-fullcalendar');
	      var startHeight = calendar.height() + 100;

	      featuredEventsBlock.css('height', startHeight);
	    };

	    if ($(window).width() >= 1024) {
	      equalHeightsEventTop();
	    }
	  }
	};

	exports.default = CalendarEqualHeight;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _equalHeights = __webpack_require__(16);

	var _equalHeights2 = _interopRequireDefault(_equalHeights);

	var _calendarEqualHeight = __webpack_require__(14);

	var _calendarEqualHeight2 = _interopRequireDefault(_calendarEqualHeight);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();
	// import jQuery from "jquery";


	'use strict'; // jshint ignore:line

	var WindowResize = {

	  init: function init() {

	    var equalHeightsLEatestNews = function equalHeightsLEatestNews() {
	      var rowWidth = $('#block-views-block-latest-news-block-1').find('.views-row').width();

	      var rowBackground = $('#block-views-block-latest-news-block-1').find('.views-row').find('.views-row-background');

	      rowBackground.css('height', rowWidth);
	    };

	    if ($(window).width() > 768) {
	      _equalHeights2.default.init();
	    }

	    if ($(window).width() <= 1280) {
	      equalHeightsLEatestNews();
	    }

	    $(window).resize(function () {
	      // EqualHeights.init();
	      // equalHeightsEventTop();

	      if ($(window).width() >= 768) {
	        _equalHeights2.default.init();
	      }

	      if ($(window).width() >= 1024) {
	        _calendarEqualHeight2.default.init();
	      }
	    });
	  }
	};

	exports.default = WindowResize;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var EqualHeight = {
	  $eventsHome: $('#block-latestevents').find('.node--type-content-events').find('.content'),
	  $newsHome: $('#block-views-block-regional-news-block-1').find('.node--type-content-news').find('.news-content'),
	  $newsNews: $('.page-news').find('.node--type-content-news').find('.news-content'),
	  $newsLacaView: $('.page-laca-view').find('.node--type-content-news').find('.news-content'),
	  //$featuredEventsBlock: $('#block-views-block-events-listing-block-1').find('.view-events-listing'),
	  $featuredEventsImage: $('#block-views-block-events-listing-block-1').find('.view-events-listing').find('.image-wrapp'),
	  $partnersSliderItem: $('.view-id-simple_ad').find('.views-rows').find('.views-row'),
	  $instagramContent: $('.twit-insta-block').find('#instawidget_instagram'),
	  $twitterContent: $('.twit-insta-block').find('c-twitter'),
	  $partnerItem: $('.view-partners').find('.views-row'),
	  $frameworks: $('.view-frameworks').find('.views-row').find('.views-field-title').find('.field-content'),

	  //$calendar: $('#calendar'),

	  init: function init() {

	    var equalHeights = function equalHeights(elm) {
	      setTimeout(function () {
	        var x = 0;

	        elm.height('auto');

	        elm.each(function (index, el) {
	          if ($(el).height() > x) {
	            x = $(el).height();
	          }
	        });

	        elm.height(x + 1);
	      }, 100);
	    };

	    var equalHeightsWidths = function equalHeightsWidths() {
	      var imageWidth = EqualHeight.$featuredEventsImage.width();

	      EqualHeight.$featuredEventsImage.height(imageWidth);
	    };

	    var equalHeightsLEatestNews = function equalHeightsLEatestNews() {
	      var rowWidth = $('#block-views-block-latest-news-block-1').find('.views-row').width();

	      var rowBackground = $('#block-views-block-latest-news-block-1').find('.views-row').find('.views-row-background');

	      if ($(window).width() <= 1250) {
	        rowBackground.css('height', rowWidth);
	      }
	    };

	    //Equal heights
	    equalHeights(EqualHeight.$eventsHome);
	    equalHeights(EqualHeight.$newsHome);
	    equalHeights(EqualHeight.$newsLacaView);
	    equalHeights(EqualHeight.$newsNews);
	    equalHeights(EqualHeight.$partnersSliderItem);
	    equalHeights(EqualHeight.$partnerItem);
	    equalHeights(EqualHeight.$frameworks);

	    //Event top equal heights


	    equalHeightsWidths();
	    equalHeightsLEatestNews();
	  }
	};

	exports.default = EqualHeight;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	       value: true
	});

	var _select = __webpack_require__(13);

	var _select2 = _interopRequireDefault(_select);

	var _equalHeights = __webpack_require__(16);

	var _equalHeights2 = _interopRequireDefault(_equalHeights);

	var _searchPage = __webpack_require__(5);

	var _searchPage2 = _interopRequireDefault(_searchPage);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line

	var AjaxComplete = {

	       init: function init() {

	              $(document).ajaxComplete(function () {

	                     _equalHeights2.default.$newsHome = $('#block-views-block-regional-news-block-1').find('.node--type-content-news').find('.content');
	                     _equalHeights2.default.$newsNews = $('.page-news').find('.node--type-content-news').find('.news-content');

	                     _select2.default.init();

	                     _equalHeights2.default.init();
	                     ;
	                     var regionsFilterText = $('.page-node .view-regional-news select option:selected').text();
	                     var seeMoreUrl = regionsFilterText == 'Select a region' || regionsFilterText == '- Any -' ? '/news' : '/news/' + regionsFilterText.replace(new RegExp(' ', 'g'), '-');

	                     $('.page-node .view-regional-news .more-link a').attr('href', seeMoreUrl.toLowerCase());

	                     //console.log('ajax complete')
	              });
	       }
	};

	exports.default = AjaxComplete;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var Pagination = {
	    /*-------------------------------------------------------------------------------
	    # Cache dom and strings
	    -------------------------------------------------------------------------------*/

	    /*-------------------------------------------------------------------------------
	    # Initialize
	    -------------------------------------------------------------------------------*/

	    init: function init() {
	        var pagerItem = $('.pager').find('.pager__item > a');

	        pagerItem.on('click', function (e) {
	            var vievTarget = $(e.currentTarget).closest('.views-element-container');
	            var offsetView = vievTarget.offset().top - 250;
	            console.log();

	            $(document).ajaxComplete(function () {

	                $([document.documentElement, document.body]).animate({
	                    scrollTop: offsetView
	                }, 100);

	                $([document.documentElement, document.body]).animate({
	                    scrollTop: offsetView + 1
	                }, 100);
	            });
	        });
	    }
	};

	exports.default = Pagination;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _equalHeights = __webpack_require__(16);

	var _equalHeights2 = _interopRequireDefault(_equalHeights);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var Accordion = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$accordionHeader: $('.paragraph--type--lot').find('.field-field_description'),

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/

		init: function init() {

			var equalHeights = function equalHeights(elm) {
				setTimeout(function () {
					var x = 0;

					elm.height('auto');

					elm.each(function (index, el) {
						if ($(el).height() > x) {
							x = $(el).height();
						}
					});

					elm.height(x + 1);
				}, 100);
			};

			var frameworksLots = $('.field-field_framewok_lots').find('.supplier-wrapp').find('> div').find('article > h2');

			//Accordion, move in own component
			Accordion.$accordionHeader.on('click', function (e) {
				if (!$(e.target).hasClass('toggler')) {
					$(e.target).parent().parent().siblings().find('.field-field_supplier').slideUp('fast');
					$(e.target).parent().parent().siblings().find('.field-field_description').removeClass('active');
					$(e.target).parent().parent().siblings().find('.field-field_description').find('.toggler').text('SHOW');
					//Toggle open/close 
					$(e.target).next('.field-field_supplier').slideToggle('fast');
					$(e.target).toggleClass('active');

					var position1 = $(e.target).offset().top;

					setTimeout(function () {
						var position2 = $('.field-field_framewok_lots').find('.active').offset().top;
						//console.log('2',position2);

						if (position1 !== position2) {
							//console.log('nije')
							setTimeout(function () {
								$('html, body').animate({ scrollTop: position2 - 170 });
							}, 100);
						} else {
							//console.log('jeste')
						}
					}, 200);

					var togglerText = $(e.target).find('.toggler');

					if (!$(e.target).hasClass('active')) {
						togglerText.text('SHOW');
					} else {
						togglerText.text('HIDE');
					}
				}

				equalHeights(frameworksLots);
			});
		}
	};

	exports.default = Accordion;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var MagazineArchive = {
	  /*-------------------------------------------------------------------------------
	  # Cache dom and strings
	  -------------------------------------------------------------------------------*/
	  $magazineArchiveMenu: $('#block-publicationarchive > ul > li.menu-item--expanded'),
	  $magazineArchiveMenuFirst: $('#block-publicationarchive > ul > li.menu-item--expanded:first-of-type'),

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {
	    // bind events
	    if (_global2.default.varsWindowWidth < 992) {

	      //   MagazineArchive.$magazineArchiveMenuFirst.children('a').addClass('active');
	      //   MagazineArchive.$magazineArchiveMenuFirst.children('ul').addClass('active');

	      MagazineArchive.$magazineArchiveMenu.children('a').on('click', function (e) {
	        e.preventDefault();
	        var self = $(e.currentTarget);
	        if (!self.siblings('ul').hasClass('active')) {

	          MagazineArchive.$magazineArchiveMenu.children('ul').removeClass('active');
	          MagazineArchive.$magazineArchiveMenu.children('a').removeClass('active');
	          self.siblings('ul').addClass('active');
	          self.addClass('active');

	          setTimeout(function () {
	            $('html, body').animate({
	              scrollTop: $(self).offset().top - 270
	            }, 400);
	          }, 350);
	        } else {
	          self.removeClass('active');
	          self.siblings('ul').removeClass('active');
	        }
	      });
	    } else {
	      MagazineArchive.$magazineArchiveMenu.children('a').on('click', function (e) {
	        e.preventDefault();
	      });
	      if ($('#block-publicationarchive').length) {
	        $('.menu__link').children('.menu-item').children('a').each(function (index, el) {
	          console.log($(el));
	          $(el).on('click', function (e) {
	            e.preventDefault();
	            $(el).toggleClass('menu-item--expanded-mobile');
	          });
	        });
	      }
	    }
	  }
	};

	exports.default = MagazineArchive;

/***/ })
/******/ ]);